import { createAsyncThunk } from '@reduxjs/toolkit';
import { ThunkAPIModel } from '../../../models/ThunkAPI.model';
import { Claim, ClaimRequest } from '../../../models/Claim';
import { createClaim } from '../../../services/vestingApi';
import { VestingClaimErrorType } from '../../../models/VestingClaimErrorType';

export const startClaim = createAsyncThunk<
  Claim,
  ClaimRequest,
  ThunkAPIModel<VestingClaimErrorType>
>('claim/startClaim', async (request, thunkApi) => {
  try {
    const { vestingContractAddress, claim } = request;
    return await createClaim(vestingContractAddress, claim);
  } catch (error) {
    return thunkApi.rejectWithValue(error.message);
  }
});
